import { ContactPerson } from '../../../../../types/contactPerson'
import { CustomerForm } from '../../../../../types/customerForm'

export const updateContactPersonsAtIndex = (contacts: ContactPerson[], editedIndex: number, values: CustomerForm) => {
  const { contactEmail, contactFirstName, contactLastName, isContactPrimary } = values

  const updatedContacts = [...contacts]

  updatedContacts[editedIndex] = {
    ...updatedContacts[editedIndex],
    email: contactEmail,
    firstName: contactFirstName,
    lastName: contactLastName,
    isPrimary: !!isContactPrimary,
  }

  return updatedContacts
}
